import { Table, Container, Button, Row, Col, Input } from 'reactstrap';
import React, { useState } from 'react';
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
import { NumberWithCommas } from "../../share/NumberWithCommas";
import {RiFileExcel2Line} from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
import "./Reports.css"
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report1915() {

    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [othYearSelected, setOThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [thMonthSelected, setThMonthSelected] = React.useState(new Date().getMonth())

    const [Re1915data, setRe1915data] = useState([]);

    pdfMake.fonts = {
        THSarabunNew: {
            normal: 'THSarabunNew.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNew BoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-MediumItalic.ttf'
        }
    }

    async function getR1915() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        formData.append("othYear", othYearSelected);
        formData.append("month", thMonthSelected);
        const res1915 = await fetch("/api/BorrowReports/getV1915", {
            method: 'POST',
            body: formData
        })
        const Re1915data = await res1915.json()
        setRe1915data(Re1915data.dataenum)
        console.log(Re1915data)
    }

    const [Re1915yeardata, setRe1915yeardata] = React.useState([]);
    async function getR1915year() {
        const res = await fetch("/api/BorrowReports/getyear1915")
        const Re1915yeardata = await res.json()
        setRe1915yeardata(Re1915yeardata.dataenum)
        console.log(Re1915yeardata)
    }



    const y2 = Re1915yeardata.filter(n => n.yearTh >= othYearSelected);

    React.useEffect(() => {
        getR1915()
        getR1915year()
    }, [thYearSelected, othYearSelected, thMonthSelected]);

   

    var monthTh = "";
    if (thMonthSelected == 1) {
        var monthTh = "มกราคม";
    }
    if (thMonthSelected == 2) {
        var monthTh = "กุมภาพันธ์";
    }
    if (thMonthSelected == 3) {
        var monthTh = "มีนาคม";
    }
    if (thMonthSelected == 4) {
        var monthTh = "เมษายน";
    }
    if (thMonthSelected == 5) {
        var monthTh = "พฤษภาคม";
    }
    if (thMonthSelected == 6) {
        var monthTh = "มิถุมายน";
    }
    if (thMonthSelected == 7) {
        var monthTh = "กรกฎาคม";
    }
    if (thMonthSelected == 8) {
        var monthTh = "สิงหาคม";
    }
    if (thMonthSelected == 9) {
        var monthTh = "กันยายน";
    }
    if (thMonthSelected == 10) {
        var monthTh = "ตุลาคม";
    }
    if (thMonthSelected == 11) {
        var monthTh = "พฤศจิกายน";
    }
    if (thMonthSelected == 12) {
        var monthTh = "ธันวาคม";
    }
    
    const PrintPDF = () => {
        var tablebody = [[{ text: 'ปีงบประมาณ', rowSpan: 5, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ทำสัญญา (บริษัท)', rowSpan: 5, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'อยู่ระหว่างการฝึกอบรม/ทดสอบ', rowSpan: 2, colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' },  {}, { text: 'ไม่สามารถฝึกอบรมได้ (บริษัท)', rowSpan: 5, fillColor: '#cccccc', bold: true, alignment: 'center'  }, { text: 'รวม (บริษัท)', rowSpan: 5, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ฝึกอบรม/ทดสอบฯฝีมือแรงงานเสร็จสิ้นแล้ว', colSpan: 12, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
            [{}, {}, {}, {}, {}, {}, { text: 'รายงานการติดตามประเมินผลฯ แบบกย.๖', colSpan: 9, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}, {}, {}, {}, {}, { text: 'ส่ง กย.๖ (บริษัท)', rowSpan: 4, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ยังไม่ส่ง กย.๖ (บริษัท)', rowSpan: 4, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'รวม (บริษัท)', rowSpan: 4, fillColor: '#cccccc', bold: true, alignment: 'center' }],
            [{}, {}, { text: 'ฝึกได้ตามแผน (บริษัท)', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'แจ้งขอเลื่อนฝึก (บริษัท)', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, { text: 'การฝึกอบรมลูกจ้างตามสัญญา', colSpan: 4, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, { text: 'การใช้จ่ายเงินกู้ตามสัญญา', colSpan: 5, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}, {}, {}, {}],
            [{}, {}, {}, {}, {}, {}, { text: 'ครบ', colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, { text: 'ไม่ครบ', colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, { text: 'ครบ', colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, { text: 'ไม่ครบ', colSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}, {}],
            [{}, {}, {}, {}, {}, {}, { text: 'จำนวนบริษัท', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนคน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนบริษัท', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนคน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนบริษัท', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนเงิน (บาท)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนบริษัท', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนเงิน (บาท)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนเงินคงเหลือ', fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}]];
        Re1915data.forEach(function (item) {
            var rowdata = [{ text: 'ปีงบประมาณ ' + item.year, alignment: 'left' }, { text: item.companyNo, alignment: 'right' }, { text: item.trainInPlan, alignment: 'right' }, { text: item.trainInNotPlan, alignment: 'right' }, { text: (NumberWithCommas(item.cannotTrainTest)), alignment: 'right' }, { text: (NumberWithCommas(item.sum)), alignment: 'right' }, { text: item.contractCompFully, alignment: 'right' }, { text: (NumberWithCommas(item.contractEmpFully)), alignment: 'right' }, { text: item.contractCompCantFully, alignment: 'right' }, { text: (NumberWithCommas(item.contractEmpCantFully)), alignment: 'right' }, { text: item.contractEmpPay, alignment: 'right' }, { text: (NumberWithCommas(item.contractEmpTrainingNot)), alignment: 'right' }, { text: (NumberWithCommas(item.contractCompPayNot)), alignment: 'right' }, { text: (NumberWithCommas(item.contractEmpPayNot)), alignment: 'right' }, { text: (NumberWithCommas(item.moneyLeft)), alignment: 'right' }, { text: item.rateSent, alignment: 'right' }, { text: item.rateDontSent, alignment: 'right' }, { text: item.sum2, alignment: 'right' }]
            tablebody.push(rowdata);
        });
        var docDefinition = {
            pageOrientation: 'landscape',
            content: [
                { text: 'แบบสรุปสถานประกอบกิจการที่กู้ยืมเงิน', bold: true, alignment: 'center', fontSize: 18 },
                { text: 'ปีงบประมาณ พ.ศ. ' + othYearSelected + ' ' + '-' + ' ' + thYearSelected, bold: true, alignment: 'center', fontSize: 18 },
                { text: 'ฝึกอบรมเสร็จเดือน ' + monthTh, bold: true, alignment: 'center', fontSize: 16 },
                {
                    table: {
                        widths: ['auto', 'auto', 'auto', 'auto', 22, 'auto', 22, 22, 22, 22, 22, 22, 22, 22, 22, 'auto', 'auto', 'auto'],
                        body: tablebody
                    },
                }],

                defaultStyle: {
                    font: 'THSarabunNew'
                }
    
            }
            pdfMake.createPdf(docDefinition).download('R1915')
        }

    let sum1 = Re1915data.reduce(function (prev, current) {
        return prev + +current.companyNo
    }, 0);
    let sum2 = Re1915data.reduce(function (prev, current) {
        return prev + +current.trainInPlan
    }, 0);
    let sum3 = Re1915data.reduce(function (prev, current) {
        return prev + +current.trainInNotPlan
    }, 0);
    let sum4 = Re1915data.reduce(function (prev, current) {
        return prev + +current.cannotTrainTest
    }, 0);
    let sum5 = Re1915data.reduce(function (prev, current) {
        return prev + +current.sum
    }, 0);
    let sum6 = Re1915data.reduce(function (prev, current) {
        return prev + +current.contractCompFully
    }, 0);
    let sum7 = Re1915data.reduce(function (prev, current) {
        return prev + +current.contractEmpFully
    }, 0);
    let sum8 = Re1915data.reduce(function (prev, current) {
        return prev + +current.contractCompCantFully
    }, 0);
    let sum9 = Re1915data.reduce(function (prev, current) {
        return prev + +current.contractEmpCantFully
    }, 0);
    let sum10 = Re1915data.reduce(function (prev, current) {
        return prev + +current.contractEmpPay
    }, 0);
    let sum11 = Re1915data.reduce(function (prev, current) {
        return prev + +current.contractEmpTrainingNot
    }, 0);
    let sum12 = Re1915data.reduce(function (prev, current) {
        return prev + +current.contractCompPayNot
    }, 0);
    let sum13 = Re1915data.reduce(function (prev, current) {
        return prev + +current.contractEmpPayNot
    }, 0);
    let sum14 = Re1915data.reduce(function (prev, current) {
        return prev + +current.moneyLeft
    }, 0);
    let sum15 = Re1915data.reduce(function (prev, current) {
        return prev + +current.rateSent
    }, 0);
    let sum16 = Re1915data.reduce(function (prev, current) {
        return prev + +current.rateDontSent
    }, 0);
    let sum17 = Re1915data.reduce(function (prev, current) {
        return prev + +current.sum2
    }, 0);
   
    return (
        <Container>
            <div>
                {/* <div style={{ display: 'flex', paddingBottom: '20px', justifyContent: 'center' }}>
                    <h3 className='mt-1 text-center' style={{ lineHeight: 'inherit' }}>
                        ปีงบประมาณ
                    </h3>
                    <Input
                        style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={othYearSelected}
                        onChange={(e) => {
                            setOThYearSelected(e.target.value)
                        }}
                    >
                        {Re1915yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                    <h3 style={{ lineHeight: 'inherit' }}>ถึง</h3>
                    <Input
                        style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {y2.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                   
                   
                </div> */}
                <div className='d-flex justify-content-center align-items-center'>
                    <span className='header-select-year mx-3'>ปีงบประมาณ </span>
                    <Input
                        // className='report-select-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={othYearSelected}
                        onChange={(e) => {
                            if(e.target.value !== "กรุณาเลือก"){
                                setOThYearSelected(e.target.value)
                            } else {
                                return;
                            }
                            
                        }}
                    >
                        <option disabled defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                        {Re1915yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                        
                    </Input>
                    <span className='header-select-year mx-3'> ถึง </span>
                    <Input
                        // className='report-select-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            if(e.target.value !== "กรุณาเลือก"){
                                setThYearSelected(e.target.value)
                            } else {
                                return;
                            }
                            
                        }}
                    >
                        <option disabled defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                        {y2?.map((item, i) => (
                            <option className='option-style' value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                        
                    </Input>
                   
                </div>



                <div className='d-flex justify-content-center align-items-center mt-3'>
                    <span className='header-select-year mx-3'>ฝึกอบรมเสร็จเดือน</span>
                   
                    <Input
                        // className='report-select-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="thMonth"
                        name="thMonth"
                        type="select"
                        value={thMonthSelected}
                        onChange={(e) => {
                            setThMonthSelected(e.target.value)
                        }}
                    >
                        <option value={1}>
                            มกราคม
                        </option>
                        <option value={2}>
                            กุมภาพันธ์
                        </option>
                        <option value={3}>
                            มีนาคม
                        </option>
                        <option value={4}>
                            เมษายน
                        </option>
                        <option value={5}>
                            พฤษภาคม
                        </option>
                        <option value={6}>
                            มิถุมายน
                        </option>
                        <option value={7}>
                            กรกฎาคม
                        </option>
                        <option value={8}>
                            สิงหาคม
                        </option>
                        <option value={9}>
                            กันยายน
                        </option>
                        <option value={10}>
                            ตุลาคม
                        </option>
                        <option value={11}>
                            พฤศจิกายน
                        </option>
                        <option value={12}>
                            ธันวาคม
                        </option>
                    </Input>
                </div>
                {/* <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/BorrowReports/xlsxV1915?thYear=${thYearSelected}&othYear=${othYearSelected}&month=${thMonthSelected}`} download>EXCEL</Button>
                        <Button className="btn2" href={`api/BorrowReports/pdfR1915?thYear=${thYearSelected}&othYear=${othYearSelected}&month=${thMonthSelected}`} download>PDF</Button>
                    </Col>
                </Row> */}
                <Row className='my-3'>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn border border-1 mx-1 btn-green" href={`api/BorrowReports/xlsxV1915?thYear=${thYearSelected}&othYear=${othYearSelected}&month=${thMonthSelected}`} download><RiFileExcel2Line/> Export Excel</Button>
                        <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR1915?thYear=${thYearSelected}&othYear=${othYearSelected}&month=${thMonthSelected}`} download><AiOutlineFilePdf/> Export PDF</Button>
                    </Col>
                </Row>
                <div className="report-wrapper">
                <Table className="styled-table text-center" bordered striped hover>
                    <thead className='styles-thead'>
                        <tr>
                            <th rowSpan="5" className='text-center'>
                                ปีงบประมาณ
                            </th>
                            <th rowSpan="5" className='text-center'>
                                ทำสัญญา(บริษัท)
                            </th>
                            <th rowSpan="2" colSpan="2" className='text-center'>
                                อยู่ระหว่างการฝึกอบรม/ทดสอบ
                            </th>
                            <th rowSpan="5" className='text-center'>
                                ไม่สามารถฝึกอบรมได้(บริษัท)
                            </th>
                            <th rowSpan="5" className='text-center'>
                                รวม(บริษัท)
                            </th>
                            <th colSpan="12" className='text-center'>
                                ฝึกอบรม/ทดสอบฯฝีมือแรงงานเสร็จสิ้นแล้ว
                            </th>
                        </tr>
                        <tr>
                            <th colSpan="9" className='text-center'>
                                รายงานการติดตามประเมินผลฯ แบบกย.6
                            </th>
                            <th rowSpan="4" className=' text-center'>
                                ส่ง กย.6 (บริษัท)
                            </th>
                            <th rowSpan="4" className='text-center'>
                                ยังไม่ส่ง กย.6 (บริษัท)
                            </th>
                            <th rowSpan="4" className=' text-center'>
                                รวม(บริษัท)
                            </th>
                        </tr>
                        <tr>
                            <th rowSpan="3" className='text-center'>
                                ฝึกได้ตามแผน(บริษัท)
                            </th>
                            <th rowSpan="3" className='text-center'>
                                แจ้งขอเลื่อนฝึก(บริษัท)
                            </th>
                            <th colSpan="4" className='text-center'>
                                การฝึกอบรมลูกจ้างตามสัญญา
                            </th>
                            <th colSpan="5" className='text-center'>
                                การใช้จ่ายเงินกู้ตามสัญญา
                            </th>
                        </tr>
                        <tr>
                            <th colSpan="2" className='text-center'>
                                ครบ
                            </th>
                            <th colSpan="2" className='text-center'>
                                ไม่ครบ
                            </th>
                            <th colSpan="2" className='text-center'>
                                ครบ
                            </th>
                            <th colSpan="3" className='text-center'>
                                ไม่ครบ
                            </th>

                        </tr>
                        <tr>
                            <th className='text-center'>
                                จำนวนบริษัท
                            </th>
                            <th className='text-center'>
                                จำนวนคน
                            </th>
                            <th className='text-center'>
                                จำนวนบริษัท
                            </th>
                            <th className='text-center'>
                                จำนวนคน
                            </th>
                            <th className='text-center'>
                                จำนวนบริษัท
                            </th>
                            <th className='text-center'>
                                จำนวนเงิน (บาท)
                            </th>
                            <th className='text-center'>
                                จำนวนบริษัท
                            </th>
                            <th className='text-center'>
                                จำนวนเงิน (บาท)
                            </th>
                            <th className='text-center'>
                                จำนวนเงินคงเหลือ
                            </th>
                        </tr>
                    </thead>
                        <tbody>
                            {Re1915data.length > 0 && Re1915data.map((item, i) => (
                                <tr>
                                    <td scope="row" className='text-start'>
                                        ปีงบประมาณ {item.year}
                                    </td>
                                    <td className='text-end'>
                                        {item.companyNo}
                                    </td>
                                    <td className='text-end'>
                                        {item.trainInPlan}
                                    </td>
                                    <td className='text-end'>
                                        {item.trainInNotPlan}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.cannotTrainTest)}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.sum)}
                                    </td>
                                    <td className='text-end'>
                                        {item.contractCompFully}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.contractEmpFully)}
                                    </td>
                                    <td className='text-end'>
                                        {item.contractCompCantFully}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.contractEmpCantFully)}
                                    </td>
                                    <td className='text-end'>
                                        {item.contractEmpPay}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.contractEmpTrainingNot)}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.contractCompPayNot)}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.contractEmpPayNot)}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.moneyLeft)}
                                    </td>
                                    <td className='text-end'>
                                        {item.rateSent}
                                    </td>
                                    <td className='text-end'>
                                        {item.rateDontSent}
                                    </td>
                                    <td className='text-end'>
                                        {item.sum2}
                                    </td>
                           
                                </tr>
                            )) || <tr><td colSpan="18" rowSpan="6" className='text-center'>No Data</td></tr>}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td className='text-end'>
                                รวม
                            </td>
                            <td className='text-end'>
                                    {sum1 }
                            </td>
                            <td className='text-end'>
                                    {sum2}
                            </td>
                            <td className='text-end'>
                                    {sum3}
                            </td>
                            <td className='text-end'>
                                    {sum4}
                            </td>
                            <td className='text-end'>
                                    {NumberWithCommas(sum5)}
                            </td>
                            <td className='text-end'>
                                    {NumberWithCommas(sum6)}
                            </td>
                            <td className='text-end'>
                                    {NumberWithCommas(sum7)}
                            </td>
                            <td className='text-end'>
                                    {sum8}
                            </td>
                            <td className='text-end'>
                                    {NumberWithCommas(sum9)}
                            </td>
                            <td className='text-end'>
                                    {sum10}
                            </td>
                            <td className='text-end'>
                                    {NumberWithCommas(sum11)}
                            </td>
                            <td className='text-end'>
                                    {NumberWithCommas(sum12)}
                            </td>
                            <td className='text-end'>
                                    {NumberWithCommas(sum13)}
                            </td>
                            <td className='text-end'>
                                    {NumberWithCommas(sum14)}
                            </td>
                            <td className='text-end'>
                                    {sum15}
                            </td>
                            <td className='text-end'>
                                    {sum16}
                            </td>
                            <td className='text-end'>
                                    {sum17}
                            </td>
                        </tr>
                    </tfoot>
                </Table>

                {/*{Borrow1915data.map((item) => (*/}
                {/*    <tr className=' d-flex justify-content-end'>*/}
                {/*        ข้อมูล ณ วันที่ {item.updateDate}*/}
                {/*    </tr>))}*/}

            </div>
            </div>
        </Container>
    );


}